<template>
  <div>
    <div
      v-show="homeShow"
      class="home"
    >
      <div class="heardBox">
        <div
          class="regultion"
          @click="regul"
        ></div>
        <!-- <van-cell  is-link @click="regul"></van-cell> -->
        <van-popup v-model="show">
          <div class="rulertop">
            <div
              class="close"
              @click="closeRule"
            ></div>
          </div>
          <div class="rulerCenter">
            <p style="font-weight:bold">活动日期</p>
            <p>2021年1月11日至2021年1月31日</p>
            <br>
            <p style="font-weight:bold">投票规则</p>
            <p>1.投票期间每人每天最多5次投票机会</p>
            <p>2.官方会从每天参与投票的用户中抽取5位幸运用户，各赠送5000播币奖励，每天的播币奖励将会在第二天发放，同时中奖结果将会在体育圈内公布</p>
            <p>3.如遇不可抗力（包括但不限于重大灾害事件、政府机关指令、网络攻击），中国体育App有权主动终止活动</p>
            <p>4.禁止网络刷票等不正当手段，发现后将永久封杀</p>
            <p>本次活动最终解释权归《中国体育》zhibo.tv所有</p>
          </div>
        </van-popup>
        <!-- <div class="distanceFinish">距投票结束还有</div> -->
        <div class="countDown">
          <div class="meter"><span>{{firstTime}}</span><span>{{lastTime}}</span></div>
          <!-- <div class="textMeter">天</div> -->
        </div>
        <div
          class="sideGo"
          @click="sideGo"
        ></div>
        <div
          class="review"
          @click="reviewGo"
        ></div>
      </div>
      <div class="bodyTab">
        <!-- <div>
        <div v-for="item in comList" :key="item.id">
          <div>{{item.name}}</div>
        </div>
      </div> -->
        <div class="nav-ul">
          <div
            class="nav-li"
            :class="{active:num===index}"
            v-for="(item,index) in cateNames"
            :key="item.id"
            @click="tabInfo(item,index)"
          >{{item.name}}</div>
        </div>
        <div class="list">
          <div
            class="box"
            v-for="(item,index) in playerList"
            :key="item.player_id"
          >
            <img
              alt=""
              :src="item.player_img"
            >
            <div class="introduce">
              <p>{{item.player_name}}</p>
              <p>
                <span class="innum">{{item.vote_num}}</span>
                <span>票</span>
              </p>
            </div>
            <div
              class="vidBtn"
              @click="vbtn(item)"
            >投 票</div>
            <div class="ranking">TOP <span>{{index+1}}</span></div>
            <div
              v-if="item.player_info.length>0"
              class="tag"
              @click="tagShow(item,index)"
            >
              <div class="sotag"></div>
            </div>
            <div
              v-if="item.sot"
              class="sotitle"
            >{{item.player_info}}</div>
          </div>
        </div>
      </div>
      <div class="criteria">
        <div class="criteria1"></div>
        <div class="criteria2">
          <p>{{awardInfo}}</p>
        </div>
      </div>
      <div class="actvity">
        <div class="actvity1"></div>
        <div class="actvity2">
          <p>1.评选结果由大众用户线上投票评定得出</p>
          <p>2.每个奖项候选名单均由评审委员会成员及中国体育官方拟定</p>
          <p>3.投票期间每人每天拥有5次投票机会</p>
          <p>4.每个奖项获奖名单将于2月1日在线上揭晓</p>
        </div>
      </div>
      <!-- <div class="flotage" @click="share">
            <img src="../assets/9.png" alt="" >
          </div> -->
      <div class="footerBox">
        <div class="bj"></div>
        <p>本次活动最终解释权归《中国体育》zhibo.tv所有</p>
      </div>
    </div>
    <div
      class="side"
      v-show="sideGoShow"
    >
      <div
        class="sideClose"
        @click="sideClose"
      ></div>
      <img
        src="https://images.zhibo.tv/2021/0111/icon_8.jpg"
        alt=""
        width="100%"
      >
    </div>
    <div
      class="reviewPage"
      v-show="reviewShow"
    >
      <div
        class="reviewClose"
        @click="reviewClose"
      ></div>
      <img
        src="https://images.zhibo.tv/2021/0111/icon_11.jpg"
        alt=""
        width="100%"
      >
    </div>

  </div>
</template>

<script>
// @ is an alias to /src

import { getComment } from "@/api/detail.js";
export default {
  name: "combat",
  data () {
    return {
      comList: '',
      homeShow: true,
      show: false,
      sideGoShow: false,
      reviewShow: false,
      cateNames: [],
      shareInfo: {},
      playerList: [],
      num: 0,
      voteId: '',
      userToken: '',
      awardInfo: '',
      endTime: 1,
      firstTime: '',
      lastTime: ''
    }
  },
  created () {
    this.vueQuery = this.$route.query
    this.voteId = this.vueQuery.combat_vote_id
    this.userToken = this.vueQuery.token
    console.log(this.vueQuery)
    this.combatList(this.voteId);
    this.shareConfig(this.voteId);

    // this.getUserInfo()
    // this.getwxShareInfo()
  },
  watch: {
    endTime () {
      console.log(this.endTime)

    }
  },
  mounted () {
  },
  methods: {
    combatList (voteId) {
      let url = this.$address + 'rest.zhibo.tv/combat-vote/award-list'
      this.$http.jsonp(url, {
        params: {
          combat_vote_id: voteId
        }
      }).then(res => {
        console.log(res.body)
        this.comList = res.body.data[0]
        this.cateNames = this.comList.list
        this.endTime = res.body.data.vote_end_time
        if (String(this.endTime).length > 1) {
          this.firstTime = String(this.endTime)[0]
          this.lastTime = String(this.endTime)[1]
          console.log(1)
        } else {
          this.firstTime = 0
          this.lastTime = this.endTime
          console.log(2)
        }
        console.log(this.cateNames)
        this.awardInfo = this.cateNames[0].award_info
        this.awardId = this.cateNames[0].award_id
        this.awardType = this.cateNames[0].award_type
        this.playerInfo(this.awardId, this.awardType)
      })
    },
    playerInfo (awardId, awardType) {
      let url = this.$address + 'rest.zhibo.tv/combat-vote/player-list'
      this.$http.jsonp(url, {
        params: {
          award_id: awardId,
          award_type: awardType
        }
      }).then(res => {
        console.log(res.body)
        this.playerList = res.body.data
        this.playerList.forEach((item) => {
          this.$set(item, 'sot', false)
        })
        console.log(this.playerList)
      })
    },
    shareConfig (voteId) {
      let url = this.$address + 'rest.zhibo.tv/combat-vote/share-config'
      this.$http.jsonp(url, {
        params: {
          combat_vote_id: voteId,
        }
      }).then(res => {
        console.log(res.body)
        this.shareInfo = res.body.data
        this.shareInfo.des = this.shareInfo.subtitle
        this.shareInfo.imageUrl = this.shareInfo.share_img
        this.shareInfo.jumpUrl = window.location.origin + window.location.pathname + '?combat_vote_id=' + this.voteId + '&share=1',
          console.log(this.shareInfo)
        this.share()
      })
    },
    vbtn (item) {
      if (this.vueQuery.share) {
        this.downApply()
      } else {
        if (this.vueQuery.token !== '' && this.vueQuery.token !== null && this.vueQuery.token !== undefined) {
          console.log(item)
          let url = this.$address + 'rest.zhibo.tv/combat-vote/vote-go'
          this.$http.jsonp(url, {
            params: {
              player_id: item.player_id,
              award_type: this.awardType,
              token: this.userToken,
            }
          }).then(res => {
            console.log(res.body)
            if (res.body.status === '40003') {
              this.$toast({
                message: '本奖项今日票数已投完'
              });
            }
            else if (res.body.status === 200) {
              this.playerInfo(this.awardId, this.awardType)
              this.$toast({
                message: '投票成功，本奖项剩余' + res.body.data.num + '票'
              });
            } else if (res.body.status == '40001') {
              this.$toast({
                message: '投票活动暂未开启'
              });
            } else if (res.body.status === '40002') {
              this.$toast({
                message: '投票活动已截止，感谢您的参与'
              });
            } else if (res.body.status === '40004') {
              this.$toast({
                message: '选手票数已达今日上限'
              });
            } else {
              this.$toast({
                message: '投票失败，请重试'
              });
            }
          })
        } else {
          try {
            window.webkit.messageHandlers.isnotlogin.postMessage('login');
          } catch (e) { window.console.log('') }
          try {
            window.LiveAppJS.login();
          } catch (e) { window.console.log('') }
        }
      }

    },
    regul () {
      console.log(222)
      this.show = true
    },
    closeRule () {
      this.show = false
    },
    sideGo () {
      this.sideGoShow = true
      this.homeShow = false
    },
    reviewGo () {
      this.reviewShow = true
      this.homeShow = false
    },
    sideClose () {
      this.sideGoShow = false
      this.homeShow = true
    },
    tagShow (item, index) {
      console.log(item)
      item.sot = !item.sot
      console.log(item.sot)
    },
    reviewClose () {
      this.reviewShow = false
      this.homeShow = true
    },
    tabInfo (item, index) {
      this.num = index
      this.awardInfo = item.award_info
      this.awardId = item.award_id
      this.awardType = item.award_type
      this.playerInfo(this.awardId, this.awardType)
      console.log(item, index)
    },
    // 唤醒app
    gotoApp () {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        if (this.$route.name === 'atlas-id') {
          location.href = `zhibotv://www.zhibo.tv:80/ios?json={"code":"${this.code}","value1":${this.value1},"value2":"${this.title}","from":"zhibotv"}`
        } else {
          location.href = `zhibotv://www.zhibo.tv:80/ios?json={"code":"${this.code}","value1":${this.value1},"from":"zhibotv"}`
        }
      } else if (this.$route.name === 'atlas-id') {
        location.href = `zhibotv://www.zhibo.tv:80/android?json={"code":"${this.code}","value1":${this.value1},"value2":"${this.title}","from":"zhibotv"}`
      } else {
        location.href = `zhibotv://www.zhibo.tv:80/android?json={"code":"${this.code}","value1":${this.value1},"from":"zhibotv"}`
      }
      setTimeout(() => {
        this.downApply()
      }, 500)
    },
    // 分享
    share () {
      // this.shareInfo = {
      //   title: '1',
      //   imageUrl: 'https://images.zhibo.tv/2020/0405/share.jpg',
      //   jumpUrl: window.location.origin + window.location.pathname + '?combat_vote_id=' + this.voteId + '&share=1',
      //   des: "用运动抗击疫情，打造身体的最强防线。点击报名"
      // }
      console.log(this.shareInfo)
      try {
        window.webkit.messageHandlers.shareProduct.postMessage(this.shareInfo);
      } catch (e) {
        window.console.log("ios启用分享按钮", e);
      }
      try {
        window.LiveAppJS.shareProduct(this.shareInfo.title, this.shareInfo.desc, this.shareInfo.imageUrl, this.shareInfo.jumpUrl);
      } catch (e) {
        window.console.log("Android启用分享按钮", e);
      }

    },
    // 唤醒失败，跳转应用宝
    downApply () {
      const ua = navigator.userAgent
      const isAndroid = ua.includes('Android') || ua.includes('Linux')
      const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      const isWeixin = ua.indexOf('MicroMessenger') > 0 // 是否微信
      if (isWeixin) {
        window.location.href = 'https://android.myapp.com/myapp/detail.htm?apkName=com.seca.live&ADTAG=mobile'
      } else if (isAndroid) {
        // window.open('https://android.myapp.com/myapp/detail.htm?apkName=com.seca.live&ADTAG=mobile')
        window.location.href = 'https://android.myapp.com/myapp/detail.htm?apkName=com.seca.live&ADTAG=mobile'
      } else if (isIOS) {
        // window.open('https://apps.apple.com/cn/app/zhi-botv-feng-ge-jiong-yi/id1064012897')
        window.location.href = 'https://apps.apple.com/cn/app/zhi-botv-feng-ge-jiong-yi/id1064012897'
      }
    },
    // 跳转应用宝下载
    gotodown () {
      window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.seca.live&info=DF250BAD4E6520748450EBAC1CBCD9BE'
    },
  }
};
</script>

<style lang='less'>
@media screen and (min-width:750px) {
  body ,html{ font-size: 100px !important;}
}
.home {
  max-width: 7.5rem;
  margin: 0 auto;
  background: url("https://images.zhibo.tv/2021/0111/icon_1.jpg") no-repeat;
  background-size: 100% 100%;
  font-family: OPPOSans;
}
.heardBox {
  position: relative;
  height: 8rem;
  background: url(https://images.zhibo.tv/2021/0111/icon_2.png) no-repeat;
  background-size: contain;
  .regultion {
    position: absolute;
    top: 0.8rem;
    right: 0.2rem;
    color: #b28850;
    font-size: 12px;
    width: 1rem;
    height: 0.4rem;
  }
  .rulertop {
    height: 1.3rem;
    position: relative;
    .close {
      position: absolute;
      right: 0.2rem;
      top: 0.2rem;
      width: 0.4rem;
      height: 0.4rem;
    }
  }
  .rulerCenter {
    height: 4.9rem;
    overflow: auto;
    margin: 0.3rem;
    font-size: 0.24rem;
    color: #fff;
    line-height: 1.5;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .countDown {
    position: absolute;
    top: 4.7rem;
    left: 50%;
    transform: translate(-50%);
    // background: red;
    width: 2.45rem;
    height: 0.84rem;
    line-height: 0.84rem;
    font-size: 0.72rem;
    display: flex;
    align-content: center;
    color: #b28850;
    background: linear-gradient(0deg, #efbe77 0%, #67491f 100%);
    -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
    .meter {
      span {
        display: inline-block;
        width: 0.71rem;
        text-align: center;
        margin-right: 0.17rem;
        // background:red;
      }
    }
  }
  .sideGo {
    width: 1.32rem;
    height: 0.4rem;
    top: 6.3rem;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
  }
  .review {
    position: absolute;
    width: 0.4rem;
    height: 1.4rem;
    top: 5.3rem;
    right: 0;
  }
  .distanceFinish {
    font-size: 50/2px;
    font-family: OPPOSans;
    font-weight: normal;
    color: #b28850;
    background: linear-gradient(0deg, #efbe77 0%, #67491f 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.bodyTab {
  .nav-ul {
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
    height: 0.9rem;
    &::-webkit-scrollbar {
      display: none;
    }
    padding: 9px 30/2px 0;

    .nav-li {
      position: relative;
      flex-shrink: 0;
      width: 1.6rem;
      height: 0.68rem;
      font-size: 0.25rem;
      font-family: SourceHanSerifSC;
      font-weight: 800;
      color: #b28850;
      background: linear-gradient(0deg, #efbe77 0%, #67491f 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin-right: 0.22rem;
      text-align: center;
      // padding-bottom: 0.3rem;
      // overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      word-break: break-all;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      &:last-child {
        margin-right: 0;
      }
    }
    .active::after {
      content: "";
      position: absolute;
      width: 1.6rem;
      height: 0.11rem;
      background: #b28850;
      border-radius: 5px;
      left: 0;
      bottom: -0.16rem;
    }
  }
  .list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0.3rem;
    .box {
      box-sizing: border-box;
      position: relative;
      width: 3.3rem;
      height: 6.08rem;
      border: 1px solid #b28850;
      margin-bottom: 0.38rem;
      padding: 0.12rem 0.15rem 0.24rem;
      img {
        width: 100%;
        height: 3.91rem;
        margin-bottom: 0.16rem;
        border: 1px solid #b28850;
      }
      .introduce {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.25rem;
        font-weight: normal;
        color: #ffffff;
        p {
          height: 0.68rem;
          &:first-child {
            width: 54%;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            word-break: break-all;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
        }
        .innum {
          margin-right: 0.12rem;
        }
      }
      .vidBtn {
        box-sizing: border-box;
        width: 100%;
        height: 0.86rem;
        line-height: 0.8rem;
        background: #000000;
        border: 1px solid #b28850;
        border-radius: 7px;
        font-size: 0.42rem;
        font-weight: normal;
        color: #b28850;
        text-align: center;
        margin-top: 0.1rem;
      }
      .ranking {
        position: absolute;
        top: 0.112rem;
        left: -0.025rem;
        width: 1.01rem;
        height: 0.57rem;
        line-height: 0.57rem;
        background: #000000;
        font-size: 0.17rem;
        font-weight: normal;
        color: #b28850;
        padding-left: 0.2rem;
        background: url("https://images.zhibo.tv/2021/0111/icon_5.png")
          no-repeat;
        background-size: contain;
      }
      .tag {
        position: absolute;
        left: 0.17rem;
        top: 3.15rem;
        width: 2.96rem;
        height: 0.91rem;
        background: linear-gradient(
          360deg,
          rgba(0, 0, 0, 0.8) 0%,
          rgba(0, 0, 0, 0) 100%
        );
        .sotag {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 0.5rem;
          height: 0.5rem;
          background: url("https://images.zhibo.tv/2021/0111/icon_10.png")
            no-repeat;
          background-size: contain;
        }
      }
      .sotitle {
        position: absolute;
        top: 3.16rem;
        width: 2.85rem;
        height: 1.55rem;
        overflow: auto;
        left: 0;
        margin-top: 0.92rem;
        font-size: 0.24rem;
        padding: 0.2rem;
        background: #000;
        color: #fff;
        z-index: 2;
      }
    }
  }
}
.criteria,
.actvity {
  .criteria1,
  .actvity1 {
    width: 4rem;
    height: 1.2rem;
    margin: 0 auto;
    background: url(https://images.zhibo.tv/2021/0111/icon_4.png) no-repeat;
    background-size: contain;
  }
  .criteria2,
  .actvity2 {
    border: 1px solid #b28850;
    border-radius: 7px;
    font-size: 0.22rem;
    line-height: 0.3rem;
    word-break: break-all;
    font-family: PingFang SC;
    font-weight: 500;
    color: #fff;
    margin: 0 0.3rem 0.23rem;
    padding: 0.23rem;
  }
}
.actvity {
  .actvity1 {
    background: url(https://images.zhibo.tv/2021/0111/icon_3.png) no-repeat;
    background-size: contain;
  }
}
.footerBox {
  padding-bottom: 1rem;
  .bj {
    width: 100%;
    height: 2rem;
    background: url(https://images.zhibo.tv/2021/0111/icon_6.png) no-repeat;
    background-size: contain;
  }
  p {
    margin-top: 0.3rem;
    font-size: 0.21rem;
    font-weight: normal;
    color: #ffffff;
    text-align: center;
  }
}
.flotage {
  position: fixed;
  right: 0;
  bottom: 1.6rem;
  width: 1rem;
  height: 0.9rem;
  img {
    width: 100%;
    height: 100%;
  }
}

.van-popup {
  width: 5.32rem;
  height: 6.8rem;
  background: url(https://images.zhibo.tv/2021/0111/icon_7.png) no-repeat;
  background-size: contain;
}
.sideClose,
.reviewClose {
  position: absolute;
  top: 0.3rem;
  left: 0.3rem;
  width: 0.9rem;
  height: 0.4rem;
}
</style>

